const state = {
  ChiefOrderListTabActive: '1', // 首级集成商 tab激活哪一个
  ChiefContractListTabActive: '1', // 合同处理列表 tab激活哪一个
  OrderPersionContractListTabActive: '1', // 订单员合同处理列表 tab激活哪一个
  OrderPersionInterContractListTabActive: '1',
  FinanceListTabActive: '1', // 财务列表 tab激活哪一个
  IndustryRebateListTabActive: '1', // 行业返利列表 tab激活哪一个
  smbRebateListTabActive: '1', // smb返利列表 tab激活哪一个
  marketingManagementListTabActive: '1', // 返利审批(销管) tab激活哪一个
  rebateReceptionListTabActive: '1', // 返利接收 tab激活哪一个
  myRebateTransferLisTabActive: '1', // 我的返利转让 tab激活哪一个
  AssistantContractList: '1',
  openTickeWhole: '1', // 开票管理（合同统筹）
  openTicketFinancial: '1', // 开票管理（订单员）
  openTicketManagmentOfOrder: '1'// 开票管理（财务）
};
const mutations = {
  SETChiefOrderListTabActive (state, data) {
    state.ChiefOrderListTabActive = data;
  },
  SETassistantContractList (state, data) {
    state.AssistantContractList = data;
  },
  SETFinanceListTabActive (state, data) {
    state.FinanceListTabActive = data;
  },
  SETChiefContractListTabActive (state, data) {
    state.ChiefContractListTabActive = data;
  },
  SETOrderPersionContractListTabActive (state, data) {
    state.OrderPersionContractListTabActive = data;
  },
  SETOrderPersionInterContractListTabActive (state, data) {
    state.OrderPersionInterContractListTabActive = data;
  },
  SETIndustryRebateListTabActive (state, data) {
    state.IndustryRebateListTabActive = data;
  },
  SETSMBRebateListTabActive (state, data) {
    state.smbRebateListTabActive = data;
  },
  SETMarketingManagementListTabActive (state, data) {
    state.marketingManagementListTabActive = data;
  },
  SETRebateReceptionListTabActive (state, data) {
    state.rebateReceptionListTabActive = data;
  },
  SETMyRebateTransferLisTabActive (state, data) {
    state.myRebateTransferLisTabActive = data;
  },
  SETOpenTickeWhole (state, data) {
    state.openTickeWhole = data;
  },
  SEOpenTicketFinancial (state, data) {
    state.openTicketFinancial = data;
  },
  SETOpenTicketManagmentOfOrder (state, data) {
    state.openTicketManagmentOfOrder = data;
  }
};
const actions = {
};
export default {
  namespaced: true,
  state,
  actions,
  mutations
};
